function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 18,
  cy: 18,
  r: 18
}), /*#__PURE__*/React.createElement("filter", {
  x: "-18.1%",
  y: "-15.3%",
  width: "136.1%",
  height: "136.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.294117647   0 0 0 0 0.250980392   0 0 0 0 0.22745098  0 0 0 0.3 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu/icon-practices-selected",
  transform: "translate(4.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "practices-orange"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FF7412",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Practices-white",
  transform: "translate(7.000000, 6.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.8175692,11.0426769 C12.8175692,10.8552923 12.9698769,10.7029846 13.1563385,10.7029846 L17.5834154,10.7029846 C17.7698769,10.7029846 17.9221846,10.8552923 17.9221846,11.0426769 L17.9221846,15.4688308 C17.9221846,15.6562154 17.7698769,15.8085231 17.5834154,15.8085231 L13.1563385,15.8085231 C12.9698769,15.8085231 12.8175692,15.6562154 12.8175692,15.4688308 L12.8175692,11.0426769 Z M13.1563385,16.7112923 L17.5834154,16.7112923 C18.2683385,16.7112923 18.8268,16.1537538 18.8268,15.4688308 L18.8268,11.0426769 C18.8268,10.3568308 18.2683385,9.79836923 17.5834154,9.79836923 L13.1563385,9.79836923 C12.4714154,9.79836923 11.9138769,10.3568308 11.9138769,11.0426769 L11.9138769,15.4688308 C11.9138769,16.1537538 12.4714154,16.7112923 13.1563385,16.7112923 L13.1563385,16.7112923 Z",
  id: "Fill-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(0.000000, 0.230769)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.904153846,5.71061538 L0.904153846,1.95276923 C0.904153846,1.75615385 1.06292308,1.59553846 1.25861538,1.59553846 L21.1269231,1.59553846 C21.3226154,1.59553846 21.4813846,1.75615385 21.4813846,1.95276923 L21.4813846,5.71061538 L0.904153846,5.71061538 Z M20.5204615,22.1736923 L10.4589231,22.1736923 L10.4589231,12.2266154 C10.4589231,11.4613846 9.83769231,10.8410769 9.07338462,10.8410769 L4.49584615,10.8410769 C3.73153846,10.8410769 3.11030769,11.4613846 3.11030769,12.2266154 L3.11030769,22.1736923 L1.86507692,22.1736923 L1.86507692,6.60230769 L20.5204615,6.60230769 L20.5204615,22.1736923 Z M9.55430769,22.1736923 L4.014,22.1736923 L4.014,12.2266154 C4.014,11.9607692 4.23092308,11.7438462 4.49584615,11.7438462 L9.07338462,11.7438462 C9.33830769,11.7438462 9.55430769,11.9607692 9.55430769,12.2266154 L9.55430769,22.1736923 Z M22.3850769,6.60230769 L22.3850769,1.95276923 C22.3850769,1.25769231 21.8201538,0.691846154 21.1269231,0.691846154 L1.25861538,0.691846154 C0.564461538,0.691846154 0.000461538462,1.25769231 0.000461538462,1.95276923 L0.000461538462,6.60230769 L0.961384615,6.60230769 L0.961384615,22.1736923 L0.452769231,22.1736923 C0.202615385,22.1736923 0.000461538462,22.3767692 0.000461538462,22.6250769 C0.000461538462,22.8743077 0.202615385,23.0764615 0.452769231,23.0764615 L21.9327692,23.0764615 C22.182,23.0764615 22.3850769,22.8743077 22.3850769,22.6250769 C22.3850769,22.3767692 22.182,22.1736923 21.9327692,22.1736923 L21.4232308,22.1736923 L21.4232308,6.60230769 L22.3850769,6.60230769 Z",
  id: "Fill-3"
}))))));

function SvgPracticesOrangesvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticesOrangesvg);
export default __webpack_public_path__ + "static/media/practices-orangesvg.4dbf6d9f.svg";
export { ForwardRef as ReactComponent };